export enum SPINNERS_SIZE {
  SMALL = 'small',
  DEFAULT = 'default',
  LARGE = 'large'
}

export enum SPINNERS_SPEED {
  SLOW = 'slow',
  DEFAULT = 'default',
  FAST = 'fast'
}
